module.exports = __webpack_public_path__ + "static/media/icn-firefox.45e601c7.png";